export default __webpack_public_path__ + "static/media/close-filled-black.78f2fc9b.svg";